import { BuildInAppToolId } from '../types/appTools';
import useMessagesNotification from '../../meetings/messages/hooks/useMessagesNotification';
import useEngagementPanelNotification from '../../collaboration/EngagementPanel/decorators/useEngagementPanelNotification';
import useMeetingsNotifications from '../../meetings/schedule/hooks/useMeetingsNotifications';

export const AppToolbarNotificationHookConfig = {
    [BuildInAppToolId.Messages]: useMessagesNotification,
    [BuildInAppToolId.SessionChats]: useEngagementPanelNotification,
    [BuildInAppToolId.Meetings]: useMeetingsNotifications,
};
